(function () {
  function attribution() {
    var search = new URLSearchParams(window.location.search);
    return {
      utm_source: search.get('utm_source') || '',
      utm_medium: search.get('utm_medium') || '',
      utm_campaign: search.get('utm_campaign') || '',
      utm_content: search.get('utm_content') || ''
    };
  }

  function populateAttribution(root) {
    var values = attribution();
    root.querySelectorAll('[data-utm-field]').forEach(function (field) {
      field.value = values[field.dataset.utmField] || '';
    });
    var qaField = root.querySelector('[data-qa-field]');
    if (qaField) qaField.value = values.utm_medium === 'qa' ? 'yes' : 'no';
  }

  function preselectIdentityPath(root) {
    if (!root.matches('[data-identity-form-target]')) return;
    if (root.querySelector('[data-identity-path]:checked')) return;

    var requestedPath = new URLSearchParams(window.location.search).get('path') || '';
    var pathMap = {
      capture_kit: 'capture_kit',
      capture_now: 'capture_plus_archive',
      capture_plus_archive: 'capture_plus_archive',
      existing_print: 'existing_print'
    };
    var selectedPath = pathMap[requestedPath];
    if (!selectedPath) return;

    var input = root.querySelector('[data-identity-path="' + selectedPath + '"]');
    if (!input) return;
    input.checked = true;
    root.dataset.identityPathPreselected = selectedPath;
  }

  function initRoot(root) {
    if (root.dataset.trackingReady === 'true') return;
    root.dataset.trackingReady = 'true';
    populateAttribution(root);
    preselectIdentityPath(root);

    var errorSummary = root.querySelector('[data-validation-error-summary]');
    if (errorSummary) {
      window.requestAnimationFrame(function () {
        errorSummary.focus();
      });
    }

    var sticky = root.querySelector('[data-validation-sticky]');
    var heroCta = root.querySelector('[data-section="hero"][data-track="primary_cta_click"]');
    var stickyTarget = sticky && sticky.getAttribute('href');
    var formSection = stickyTarget && stickyTarget.charAt(0) === '#'
      ? root.querySelector(stickyTarget)
      : root.querySelector('#interest');
    if (sticky && heroCta && formSection) {
      function updateSticky() {
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var heroPassed = heroCta.getBoundingClientRect().bottom < 0;
        var formReached = formSection.getBoundingClientRect().top < window.innerHeight * 0.82;
        var navOpen = document.documentElement.classList.contains('nav-open');
        var visible = isMobile && heroPassed && !formReached && !navOpen;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        sticky.tabIndex = visible ? 0 : -1;
      }
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      window.addEventListener('b2h:nav-state-change', updateSticky);
      var navObserver = new MutationObserver(updateSticky);
      navObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

  }

  function initIdentityFormLinks() {
    document.querySelectorAll('[data-identity-form-link]').forEach(function (link) {
      if (link.dataset.identityFormLinkReady === 'true') return;

      var selector = link.getAttribute('href');
      if (!selector || selector.charAt(0) !== '#') return;
      var target = document.querySelector(selector);
      if (!target) return;

      link.dataset.identityFormLinkReady = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        target.focus({ preventScroll: true });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-b2h-validation]').forEach(initRoot);
    initIdentityFormLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
